import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_customergraphql-module"
    }}>{`Magento_CustomerGraphQl module`}</h1>
    <p>{`This module provides type and resolver information for the GraphQl module to generate customer information endpoints.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`Before installing this module, note that the Magento_CustomerGraphQl is dependent on the following modules:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_GraphQl`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_Customer`}</inlineCode></li>
    </ul>
    <p>{`Before disabling or uninstalling this module, note that the following modules depends on this module:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_WishlistGraphQl`}</inlineCode></li>
    </ul>
    <p>{`For information about a module installation in Magento 2, see `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/commerce-operations/installation-guide/tutorials/manage-modules.html"
      }}>{`Enable or disable modules`}</a>{`.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`Extension developers can interact with the Magento_CustomerGraphQl module. For more information about the Magento extension mechanism, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/plugins/"
      }}>{`Magento plugins`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/dependency-injection/"
      }}>{`The Magento dependency injection mechanism`}</a>{` enables you to override the functionality of the Magento_CustomerGraphQl module.`}</p>
    <h2 {...{
      "id": "additional-information"
    }}>{`Additional information`}</h2>
    <p>{`You can get more information about `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql/"
      }}>{`GraphQl In Magento 2`}</a>{`.`}</p>
    <h3 {...{
      "id": "graphql-query"
    }}>{`GraphQl Query`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`customer`}</inlineCode>{` query - returns information about the logged-in customer, store credit history and customer's wishlist`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`isEmailAvailable`}</inlineCode>{` query - checks whether the specified email has already been used to create a customer account. A value of true indicates the email address is available, and the customer can use the email address to create an account`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql/schema/customer/queries/customer/"
      }}>{`Learn more about customer query`}</a>{`.
`}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql/schema/customer/queries/is-email-available"
      }}>{`Learn more about isEmailAvailable query`}</a>{`.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 100.4.7.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      